import { render, staticRenderFns } from "./VEmployerCandidates.vue?vue&type=template&id=5db8d102&lang=pug"
import script from "./VEmployerCandidates.vue?vue&type=script&lang=ts"
export * from "./VEmployerCandidates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports